import PropTypes from 'prop-types';
import { X } from '@phosphor-icons/react';
import './ActiveFiltersChips.css';

/**
 * Компонент чипсов активных фильтров
 */
const ActiveFiltersChips = ({ selectedTags, onRemoveTag, onClearAll }) => {
  if (!selectedTags || selectedTags.length === 0) {
    return null;
  }

  return (
    <div className="active-filters-chips">
      <div className="chips-container">
        {selectedTags.map((tag) => {
          const iconUrl = tag.icon?.url || null;

          return (
            <div
              key={tag.id}
              className="filter-chip"
              style={{ backgroundColor: tag.color || 'var(--color-action)' }}
            >
              {iconUrl && (
                <img
                  src={iconUrl}
                  alt={tag.name}
                  className="chip-icon"
                />
              )}
              <span className="chip-name">{tag.name}</span>
              {/* Глиф Phosphor вместо знака «×»: типографский символ
                  в роли иконки — ошибка по брендбуку 9.3 */}
              <button
                className="chip-remove"
                onClick={() => onRemoveTag(tag.id)}
                aria-label={`Удалить фильтр ${tag.name}`}
              >
                <X size={16} weight="bold" />
              </button>
            </div>
          );
        })}

        {selectedTags.length > 1 && (
          <button className="clear-all-button" onClick={onClearAll}>
            Очистить все
          </button>
        )}
      </div>
    </div>
  );
};

ActiveFiltersChips.propTypes = {
  selectedTags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string,
      color: PropTypes.string,
      icon: PropTypes.shape({
        url: PropTypes.string,
      }),
    })
  ).isRequired,
  onRemoveTag: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
};

export default ActiveFiltersChips;
